// Shared banking/account copy used across surfaces so it stays consistent.
// Imported by AccountWidget (banking overview) and DirectDepositInstructionsModal
// (onboarding) — edit here, not inline.
export const ACH_WIRE_TOOLTIP =
  'Standard (ACH) is used for direct deposits and standard transfers. Wire is for same-day deposit settlement, sometimes also requested by factoring companies.';

// Why cash advance is locked (`is_cash_advance_active` false). Also locks
// Request a Rental, which unlocks on the same rule — see RequestRentalEntry.
export const CASH_ADVANCE_LOCKED_COPY = 'Requires 30 days of account activity';
